import React      from 'react';
import Loading    from 'pu-react/containers/Loading';
import Parameters from './Parameters';

import fontawesome from '@fortawesome/fontawesome';

fontawesome.config = {
  autoReplaceSvg: true,
};

export default () => (
  <div>
    <Loading />
    <div className="row">
      <div className="col-12">
        <Parameters />
      </div>
    </div>
  </div>
);
